let quizPromptImpressionFired = false;
let quizModalImpressionFired = false;
/**
 * @return `true` if impression has been fired
 * */
export function trackQuizPromptImpression() {
    if (!quizPromptImpressionFired) {
        quizPromptImpressionFired = true;
        return true;
    }
    return false;
}
/**
 * @return `true` if impression has been fired
 * */
export function trackQuizModalImpression() {
    if (!quizModalImpressionFired) {
        quizModalImpressionFired = true;
        return true;
    }
    return false;
}
